/**
 * 将内容中的 emoji code（如 :BQ0000002:）替换为对应的图片或 Unicode 字符。
 * 只替换文本节点，不会破坏已有的 HTML 结构（例如 img 的 alt 属性）。
 */
export const isEmojiImageUrl = (value: unknown): value is string => {
    if (typeof value !== 'string') return false;
    return /^(?:https?:)?\/\//i.test(value.trim());
};

export const getEmojiDisplayValue = (emoji: any): string => {
    const url = typeof emoji?.url === 'string' ? emoji.url : '';
    return url || emoji?.code || '';
};

export const replaceEmojiCodes = (content: string = '', emojiList: any[] = []): string => {
    if (!content || !emojiList.length) return content;

    const map = new Map<string, { value: string; isImage: boolean; isDefault: boolean }>();
    emojiList.forEach((category) => {
        const isDefault = category?.category === '默认';
        (category?.emoji || []).forEach((emoji: any) => {
            const value = getEmojiDisplayValue(emoji);
            if (emoji?.code && value && /^:\S+:$/.test(emoji.code)) {
                map.set(emoji.code, {
                    value,
                    isImage: isEmojiImageUrl(value),
                    isDefault,
                });
            }
        });
    });

    if (map.size === 0 || typeof document === 'undefined') return content;

    const div = document.createElement('div');
    div.innerHTML = content;

    const walk = (node: Node) => {
        if (node.nodeType === Node.TEXT_NODE) {
            let text = node.textContent || '';
            let hasReplaced = false;
            map.forEach(({ value, isImage, isDefault }, code) => {
                if (text.includes(code)) {
                    hasReplaced = true;
                    const escaped = code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    if (isImage) {
                        const size = isDefault ? 28 : 59;
                        const dataEmoji = isDefault ? 'default' : 'large';
                        const imgTag = `<img src="${value}" alt="${code}" data-emoji="${dataEmoji}" width="${size}" height="${size}" style="display:inline-block;vertical-align:middle;" />`;
                        text = text.replace(new RegExp(escaped, 'g'), () => imgTag);
                    } else {
                        // 原生 Unicode emoji 的 url 字段就是字符本身，直接显示文本，
                        // 避免生成 <img src="😉"> 之类的无效图片。
                        text = text.replace(new RegExp(escaped, 'g'), () => value);
                    }
                }
            });
            if (hasReplaced && node.parentNode) {
                const wrapper = document.createElement('span');
                wrapper.innerHTML = text;
                node.parentNode.replaceChild(wrapper, node);
            }
        } else if (node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).tagName !== 'IMG') {
            Array.from(node.childNodes).forEach(walk);
        }
    };

    Array.from(div.childNodes).forEach(walk);
    return div.innerHTML;
};
